import { FC, useEffect } from 'react';
import { Box, Button, styled, Typography } from '@mui/material';
import { ReactComponent as CustomUnderlineLong } from '@/assets/images/custom-underline-long.svg';
import useSurveyNavigate from '@/hooks/useSurveyNavigate';
import RealPhoneImage from '@/assets/images/real-phone.png';
import analytics from '@/utils/analytics/analyticsInstance';

const Container = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: 16,
  flex: 1,
}));

const Main = styled(Box)(() => ({
  flex: 1,
  maxWidth: 600,
  gap: 16,
  alignSelf: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const Underline = styled(CustomUnderlineLong)(() => ({
  top: 27,
  zIndex: -1,
  left: '50%',
  position: 'absolute',
  transform: 'translateX(-50%)',
}));

const Image = styled('img')(() => ({
  marginBottom: -62,
  maxWidth: 232,
  width: '100%',
  height: 'auto',
}));

const Footer = styled('footer')(({ theme }) => ({
  padding: 16,
  borderTopWidth: 1,
  borderTopStyle: 'solid',
  width: '-webkit-fill-available',
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: theme.palette.primary.contrastText,
  borderTopColor: theme.palette.border.main,
}));

const ShoppingStoriesStep: FC = () => {
  const { next } = useSurveyNavigate();

  useEffect(() => {
    analytics.track('webOnboardingScreenOpened', {
      screen_title: '987 shopping stories from fellow buyers',
    });
  }, []);

  return (
    <Container>
      <Main>
        <Typography
          fontSize={28}
          fontWeight={700}
          lineHeight="32px"
          whiteSpace="pre-line"
          textAlign="center"
          position="relative"
        >
          <Underline />
          {'987 shopping stories \nfrom fellow buyers'}
        </Typography>
        <Image src={RealPhoneImage} />
      </Main>
      <Footer>
        <Button
          onClick={next}
          variant="contained"
          size="large"
          sx={{ maxWidth: 600, width: '100%' }}
        >
          Continue
        </Button>
      </Footer>
    </Container>
  );
};

export default ShoppingStoriesStep;
